import { UseFormReturn } from 'react-hook-form';

export const propagateGeometryChanges = (
  geometry: any,
  geometryField: string,
  form: UseFormReturn<any>
) => {
  form.setValue(geometryField, geometry);
  if (geometry?.type === 'Point') {
    const roundedLongitude =
      Math.round(geometry.coordinates[0] * 100000) / 100000;
    const roundedLatitude =
      Math.round(geometry.coordinates[1] * 100000) / 100000;

    form.setValue('longitude', roundedLongitude);
    form.setValue('latitude', roundedLatitude);
  }

  // Here we are transmitting the geometry which is received in
  // CreateReportContext.tsx. This is done to "save" data outside the Form
  const event = new CustomEvent('instantShape', {
    detail: { [geometryField]: geometry },
  });
  window.dispatchEvent(event);
  
};
